export const departamentos = [
  {
    codigo: '01',
    value: 'Ahuachapán',
    cabecera: 'Ahuachapán',
    extension: 1239.6,
    'ISO3166-2': 'SV-AH',
  },
  {
    codigo: '02',
    value: 'Santa Ana',
    cabecera: 'Santa Ana',
    extension: 2023.17,
    'ISO3166-2': 'SV-SA',
  },
  {
    codigo: '03',
    value: 'Sonsonate',
    cabecera: 'Sonsonate',
    extension: 1225.77,
    'ISO3166-2': 'SV-SO',
  },
  {
    codigo: '04',
    value: 'Chalatenango',
    cabecera: 'Chalatenango',
    extension: 2017.0,
    'ISO3166-2': 'SV-CH',
  },
  {
    codigo: '05',
    value: 'La Libertad',
    cabecera: 'Santa Tecla',
    extension: 1652.88,
    'ISO3166-2': 'SV-LI',
  },
  {
    codigo: '06',
    value: 'San Salvador',
    cabecera: 'San Salvador',
    extension: 886.15,
    'ISO3166-2': 'SV-SS',
  },
  {
    codigo: '07',
    value: 'Cuscatlán',
    cabecera: 'Cojutepeque',
    extension: 756.19,
    'ISO3166-2': 'SV-CU',
  },
  {
    codigo: '08',
    value: 'La Paz',
    cabecera: 'Zacatecoluca',
    extension: 1223.61,
    'ISO3166-2': 'SV-PA',
  },
  {
    codigo: '09',
    value: 'Cabañas',
    cabecera: 'Sensuntepeque',
    extension: 1103.51,
    'ISO3166-2': 'SV-CA',
  },
  {
    codigo: '10',
    value: 'San Vicente',
    cabecera: 'San Vicente',
    extension: 1184.02,
    'ISO3166-2': 'SV-SV',
  },
  {
    codigo: '11',
    value: 'Usulután',
    cabecera: 'Usulután',
    extension: 2130.44,
    'ISO3166-2': 'SV-US',
  },
  {
    codigo: '12',
    value: 'San Miguel',
    cabecera: 'San Miguel',
    extension: 2077.1,
    'ISO3166-2': 'SV-SM',
  },
  {
    codigo: '13',
    value: 'Morazán',
    cabecera: 'San Francisco Gotera',
    extension: 1447.43,
    'ISO3166-2': 'SV-MO',
  },
  {
    codigo: '14',
    value: 'La Unión',
    cabecera: 'La Unión',
    extension: 2074.34,
    'ISO3166-2': 'SV-UN',
  },
]

export const MARITAL_STATUS = [
  { value: "S", label: "Soltero/a" },
  { value: "C", label: "Casado/a" },
  { value: "U", label: "Acompañado/a" },
  { value: "D", label: "Divorciado/a" },
  { value: "V", label: "Viudo/a" }
]

export const departamento_municipio = [
  {
    id: '01',
    value: 'Ahuachapán',
    cabecera: 'Ahuachapán',
    'ISO3166-2': 'SV-AH',
    extension: 1239.6,
    municipios: [
      {
        id_mun: '0101',
        value: 'Ahuachapán',
        cantones: 29,
        codigo_postal: '02101',
      },
      {
        id_mun: '0102',
        value: 'Apaneca',
        cantones: 7,
        codigo_postal: '02102',
      },
      {
        id_mun: '0103',
        value: 'Atiquizaya',
        cantones: 14,
        codigo_postal: '02103',
      },
      {
        id_mun: '0104',
        value: 'Concepción de Ataco',
        cantones: 11,
        codigo_postal: '02106',
      },
      {
        id_mun: '0105',
        value: 'El Refugio',
        cantones: 3,
        codigo_postal: '02107',
      },
      {
        id_mun: '0106',
        value: 'Guaymango',
        cantones: 14,
        codigo_postal: '02108',
      },
      {
        id_mun: '0107',
        value: 'Jujutla',
        cantones: 12,
        codigo_postal: '02109',
      },
      {
        id_mun: '0108',
        value: 'San Francisco Menéndez',
        cantones: 9,
        codigo_postal: '02113',
      },
      {
        id_mun: '0109',
        value: 'San Lorenzo',
        cantones: 6,
        codigo_postal: '02115',
      },
      {
        id_mun: '0110',
        value: 'San Pedro Puxtla',
        cantones: 6,
        codigo_postal: '02116',
      },
      {
        id_mun: '0111',
        value: 'Tacuba',
        cantones: 14,
        codigo_postal: '02117',
      },
      { id_mun: '0112', value: 'Turín', cantones: 2, codigo_postal: '02118' },
    ],
  },
  {
    id: '02',
    value: 'Santa Ana',
    cabecera: 'Santa Ana',
    'ISO3166-2': 'SV-SA',
    extension: 2023.17,
    municipios: [
      {
        id_mun: '0201',
        value: 'Candelaria de la Frontera',
        cantones: 11,
        codigo_postal: '02203',
      },
      {
        id_mun: '0202',
        value: 'Coatepeque',
        cantones: 16,
        codigo_postal: '02204',
      },
      {
        id_mun: '0203',
        value: 'Chalchuapa',
        cantones: 20,
        codigo_postal: '02205',
      },
      {
        id_mun: '0204',
        value: 'El Congo',
        cantones: 8,
        codigo_postal: '02207',
      },
      {
        id_mun: '0205',
        value: 'El Porvenir',
        cantones: 4,
        codigo_postal: '02208',
      },
      {
        id_mun: '0206',
        value: 'Masahuat',
        cantones: 5,
        codigo_postal: '02210',
      },
      {
        id_mun: '0207',
        value: 'Metapán',
        cantones: 29,
        codigo_postal: '02211',
      },
      {
        id_mun: '0208',
        value: 'San Antonio Pajonal',
        cantones: 4,
        codigo_postal: '02212',
      },
      {
        id_mun: '0209',
        value: 'San Sebastián Salitrillo',
        cantones: 4,
        codigo_postal: '02215',
      },
      {
        id_mun: '0210',
        value: 'Santa Ana',
        cantones: 35,
        codigo_postal: '02201',
      },
      {
        id_mun: '0211',
        value: 'Santa Rosa Guachipilín',
        cantones: 6,
        codigo_postal: '02216',
      },
      {
        id_mun: '0212',
        value: 'Santiago de la Frontera',
        cantones: 6,
        codigo_postal: '02217',
      },
      {
        id_mun: '0213',
        value: 'Texistepeque',
        cantones: 6,
        codigo_postal: '02218',
      },
    ],
  },
  {
    id: '03',
    value: 'Sonsonate',
    cabecera: 'Sonsonate',
    'ISO3166-2': 'SV-SO',
    extension: 1225.77,
    municipios: [
      {
        id_mun: '0301',
        value: 'Acajutla',
        cantones: 9,
        codigo_postal: '02302',
      },
      {
        id_mun: '0302',
        value: 'Armenia',
        cantones: 9,
        codigo_postal: '02303',
      },
      { id_mun: '0303', value: 'Caluco', cantones: 8, codigo_postal: '02304' },
      {
        id_mun: '0304',
        value: 'Cuisnahuat',
        cantones: 5,
        codigo_postal: '02305',
      },
      {
        id_mun: '0305',
        value: 'Santa Isabel Ishuatán',
        cantones: 8,
        codigo_postal: '02318',
      },
      {
        id_mun: '0306',
        value: 'Izalco',
        cantones: 25,
        codigo_postal: '02306',
      },
      {
        id_mun: '0307',
        value: 'Juayúa',
        cantones: 10,
        codigo_postal: '02307',
      },
      {
        id_mun: '0308',
        value: 'Nahuizalco',
        cantones: 15,
        codigo_postal: '02311',
      },
      {
        id_mun: '0309',
        value: 'Nahulingo',
        cantones: 4,
        codigo_postal: '02312',
      },
      {
        id_mun: '0310',
        value: 'Salcoatitán',
        cantones: 2,
        codigo_postal: '02313',
      },
      {
        id_mun: '0311',
        value: 'San Antonio del Monte',
        cantones: 6,
        codigo_postal: '02314',
      },
      {
        id_mun: '0312',
        value: 'San Julián',
        cantones: 9,
        codigo_postal: '02316',
      },
      {
        id_mun: '0313',
        value: 'Santa Catarina Masahuat',
        cantones: 4,
        codigo_postal: '02317',
      },
      {
        id_mun: '0314',
        value: 'Santo Domingo de Guzmán',
        cantones: 4,
        codigo_postal: '02319',
      },
      {
        id_mun: '0315',
        value: 'Sonsonate',
        cantones: 12,
        codigo_postal: '02301',
      },
      {
        id_mun: '0316',
        value: 'Sonzacate',
        cantones: 2,
        codigo_postal: '02320',
      },
    ],
  },
  {
    id: '04',
    value: 'Chalatenango',
    cabecera: 'Chalatenango',
    'ISO3166-2': 'SV-CH',
    extension: 2017,
    municipios: [
      {
        id_mun: '0401',
        value: 'Agua Caliente',
        cantones: 7,
        codigo_postal: '01302',
      },
      {
        id_mun: '0402',
        value: 'Arcatao',
        cantones: 8,
        codigo_postal: '01303',
      },
      {
        id_mun: '0403',
        value: 'Azacualpa',
        cantones: 2,
        codigo_postal: '01304',
      },
      { id_mun: '0404', value: 'Citalá', cantones: 8, codigo_postal: '01306' },
      {
        id_mun: '0405',
        value: 'Comalapa',
        cantones: 4,
        codigo_postal: '01307',
      },
      {
        id_mun: '0406',
        value: 'Concepción Quezaltepeque',
        cantones: 5,
        codigo_postal: '01308',
      },
      {
        id_mun: '0407',
        value: 'Chalatenango',
        cantones: 6,
        codigo_postal: '01301',
      },
      {
        id_mun: '0408',
        value: 'Dulce value de María',
        cantones: 9,
        codigo_postal: '01309',
      },
      {
        id_mun: '0409',
        value: 'El Carrizal',
        cantones: 4,
        codigo_postal: '01311',
      },
      {
        id_mun: '0410',
        value: 'El Paraíso',
        cantones: 3,
        codigo_postal: '01312',
      },
      {
        id_mun: '0411',
        value: 'La Laguna',
        cantones: 4,
        codigo_postal: '01313',
      },
      {
        id_mun: '0412',
        value: 'La Palma',
        cantones: 7,
        codigo_postal: '01314',
      },
      {
        id_mun: '0413',
        value: 'La Reina',
        cantones: 7,
        codigo_postal: '01315',
      },
      {
        id_mun: '0414',
        value: 'Las Vueltas',
        cantones: 6,
        codigo_postal: '01317',
      },
      {
        id_mun: '0415',
        value: 'value de Jesús',
        cantones: 6,
        codigo_postal: '01318',
      },
      {
        id_mun: '0416',
        value: 'Nueva Concepción',
        cantones: 10,
        codigo_postal: '01319',
      },
      {
        id_mun: '0417',
        value: 'Nueva Trinidad',
        cantones: 7,
        codigo_postal: '01320',
      },
      {
        id_mun: '0418',
        value: 'Ojos de Agua',
        cantones: 7,
        codigo_postal: '01321',
      },
      {
        id_mun: '0419',
        value: 'Potonico',
        cantones: 4,
        codigo_postal: '01322',
      },
      {
        id_mun: '0420',
        value: 'San Antonio de la Cruz',
        cantones: 4,
        codigo_postal: '01324',
      },
      {
        id_mun: '0421',
        value: 'San Antonio Los Ranchos',
        cantones: 1,
        codigo_postal: '01325',
      },
      {
        id_mun: '0422',
        value: 'San Fernando',
        cantones: 5,
        codigo_postal: '01326',
      },
      {
        id_mun: '0423',
        value: 'San Francisco Lempa',
        cantones: '?',
        codigo_postal: '01327',
      },
      {
        id_mun: '0424',
        value: 'San Francisco Morazán',
        cantones: 2,
        codigo_postal: '01328',
      },
      {
        id_mun: '0425',
        value: 'San Ignacio',
        cantones: 7,
        codigo_postal: '01329',
      },
      {
        id_mun: '0426',
        value: 'San Isidro Labrador',
        cantones: 5,
        codigo_postal: '01330',
      },
      {
        id_mun: '0427',
        value: 'San José Cancasque (Cancasque)',
        cantones: 4,
        codigo_postal: '01305',
      },
      {
        id_mun: '0428',
        value: 'San José Las Flores / Las Flores',
        cantones: 6,
        codigo_postal: '01316',
      },
      {
        id_mun: '0429',
        value: 'San Luis del Carmen',
        cantones: 5,
        codigo_postal: '01331',
      },
      {
        id_mun: '0430',
        value: 'San Miguel de Mercedes',
        cantones: 5,
        codigo_postal: '01332',
      },
      {
        id_mun: '0431',
        value: 'San Rafael',
        cantones: 4,
        codigo_postal: '01333',
      },
      {
        id_mun: '0432',
        value: 'Santa Rita',
        cantones: 4,
        codigo_postal: '01334',
      },
      {
        id_mun: '0433',
        value: 'Tejutla',
        cantones: 15,
        codigo_postal: '01335',
      },
    ],
  },
  {
    id: '05',
    value: 'La Libertad',
    cabecera: 'Santa Tecla',
    'ISO3166-2': 'SV-LI',
    extension: 1652.88,
    municipios: [
      {
        id_mun: '0501',
        value: 'Antiguo Cuscatlán',
        cantones: 6,
        codigo_postal: '01502',
      },
      {
        id_mun: '0502',
        value: 'Ciudad Arce',
        cantones: 15,
        codigo_postal: '01504',
      },
      { id_mun: '0503', value: 'Colón', cantones: 12, codigo_postal: '01512' },
      {
        id_mun: '0504',
        value: 'Comasagua',
        cantones: 9,
        codigo_postal: '01506',
      },
      {
        id_mun: '0505',
        value: 'Chiltiupán',
        cantones: 11,
        codigo_postal: '01507',
      },
      {
        id_mun: '0506',
        value: 'Huizúcar',
        cantones: 6,
        codigo_postal: '01508',
      },
      {
        id_mun: '0507',
        value: 'Jayaque',
        cantones: 4,
        codigo_postal: '01509',
      },
      {
        id_mun: '0508',
        value: 'Jicalapa',
        cantones: 3,
        codigo_postal: '01510',
      },
      {
        id_mun: '0509',
        value: 'La Libertad',
        cantones: 10,
        codigo_postal: '01511',
      },
      {
        id_mun: '0510',
        value: 'Nuevo Cuscatlán',
        cantones: 0,
        codigo_postal: '01513',
      },
      {
        id_mun: '0511',
        value: 'Santa Tecla',
        cantones: 10,
        codigo_postal: '01501',
      },
      {
        id_mun: '0512',
        value: 'Quezaltepeque',
        cantones: 13,
        codigo_postal: '01515',
      },
      {
        id_mun: '0513',
        value: 'Sacacoyo',
        cantones: 3,
        codigo_postal: '01516',
      },
      {
        id_mun: '0514',
        value: 'San José Villanueva',
        cantones: 5,
        codigo_postal: '01517',
      },
      {
        id_mun: '0515',
        value: 'San Juan Opico',
        cantones: 27,
        codigo_postal: '01514',
      },
      {
        id_mun: '0516',
        value: 'San Matías',
        cantones: 8,
        codigo_postal: '01518',
      },
      {
        id_mun: '0517',
        value: 'San Pablo Tacachico',
        cantones: 8,
        codigo_postal: '01519',
      },
      {
        id_mun: '0518',
        value: 'Tamanique',
        cantones: 11,
        codigo_postal: '01522',
      },
      {
        id_mun: '0519',
        value: 'Talnique',
        cantones: 7,
        codigo_postal: '01521',
      },
      {
        id_mun: '0520',
        value: 'Teotepeque',
        cantones: 10,
        codigo_postal: '01523',
      },
      {
        id_mun: '0521',
        value: 'Tepecoyo',
        cantones: 10,
        codigo_postal: '01524',
      },
      {
        id_mun: '0522',
        value: 'Zaragoza',
        cantones: 4,
        codigo_postal: '01525',
      },
    ],
  },
  {
    id: '06',
    value: 'San Salvador',
    cabecera: 'San Salvador',
    'ISO3166-2': 'SV-SS',
    extension: 886.15,
    municipios: [
      {
        id_mun: '0601',
        value: 'Aguilares',
        cantones: 5,
        codigo_postal: '01122',
      },
      { id_mun: '0602', value: 'Apopa', cantones: 8, codigo_postal: '01123' },
      {
        id_mun: '0603',
        value: 'Ayutuxtepeque',
        cantones: 2,
        codigo_postal: '01121',
      },
      {
        id_mun: '0604',
        value: 'Cuscatancingo',
        cantones: 1,
        codigo_postal: '01119',
      },
      {
        id_mun: '0605',
        value: 'El Paisnal',
        cantones: 12,
        codigo_postal: '01124',
      },
      {
        id_mun: '0606',
        value: 'Guazapa',
        cantones: 8,
        codigo_postal: '01125',
      },
      {
        id_mun: '0607',
        value: 'Ilopango',
        cantones: 4,
        codigo_postal: '01117',
      },
      {
        id_mun: '0608',
        value: 'Mejicanos',
        cantones: 0,
        codigo_postal: '01120',
      },
      { id_mun: '0609', value: 'Nejapa', cantones: 8, codigo_postal: '01126' },
      {
        id_mun: '0610',
        value: 'Panchimalco',
        cantones: 14,
        codigo_postal: '01127',
      },
      {
        id_mun: '0611',
        value: 'Rosario de Mora',
        cantones: 7,
        codigo_postal: '01128',
      },
      {
        id_mun: '0612',
        value: 'San Marcos',
        cantones: 4,
        codigo_postal: '01115',
      },
      {
        id_mun: '0613',
        value: 'San Martín',
        cantones: 6,
        codigo_postal: '01129',
      },
      {
        id_mun: '0614',
        value: 'San Salvador',
        cantones: 7,
        codigo_postal: '01101',
      },
      {
        id_mun: '0615',
        value: 'Santiago Texacuangos',
        cantones: 5,
        codigo_postal: '01130',
      },
      {
        id_mun: '0616',
        value: 'Santo Tomás',
        cantones: 9,
        codigo_postal: '01131',
      },
      {
        id_mun: '0617',
        value: 'Soyapango',
        cantones: 8,
        codigo_postal: '01116',
      },
      {
        id_mun: '0618',
        value: 'Tonacatepeque',
        cantones: 8,
        codigo_postal: '01132',
      },
      {
        id_mun: '0619',
        value: 'Ciudad Delgado',
        cantones: 8,
        codigo_postal: '01118',
      },
    ],
  },
  {
    id: '07',
    value: 'Cuscatlán',
    cabecera: 'Cojutepeque',
    'ISO3166-2': 'SV-CU',
    extension: 756.19,
    municipios: [
      {
        id_mun: '0701',
        value: 'Candelaria',
        cantones: 8,
        codigo_postal: '01402',
      },
      {
        id_mun: '0702',
        value: 'Cojutepeque',
        cantones: 7,
        codigo_postal: '01401',
      },
      {
        id_mun: '0703',
        value: 'El Carmen',
        cantones: 7,
        codigo_postal: '01403',
      },
      {
        id_mun: '0704',
        value: 'El Rosario',
        cantones: 4,
        codigo_postal: '01404',
      },
      {
        id_mun: '0705',
        value: 'Monte San Juan',
        cantones: 10,
        codigo_postal: '01405',
      },
      {
        id_mun: '0706',
        value: 'Oratorio de Concepción',
        cantones: 2,
        codigo_postal: '01406',
      },
      {
        id_mun: '0707',
        value: 'San Bartolomé Perulapía',
        cantones: 2,
        codigo_postal: '01407',
      },
      {
        id_mun: '0708',
        value: 'San Cristóbal',
        cantones: 6,
        codigo_postal: '01408',
      },
      {
        id_mun: '0709',
        value: 'San José Guayabal',
        cantones: 9,
        codigo_postal: '01409',
      },
      {
        id_mun: '0710',
        value: 'San Pedro Perulapán',
        cantones: 17,
        codigo_postal: '01410',
      },
      {
        id_mun: '0711',
        value: 'San Rafael Cedros',
        cantones: 6,
        codigo_postal: '01411',
      },
      {
        id_mun: '0712',
        value: 'San Ramón',
        cantones: 4,
        codigo_postal: '01412',
      },
      {
        id_mun: '0713',
        value: 'Santa Cruz Analquito',
        cantones: 1,
        codigo_postal: '01413',
      },
      {
        id_mun: '0714',
        value: 'Santa Cruz Michapa',
        cantones: 6,
        codigo_postal: '01414',
      },
      {
        id_mun: '0715',
        value: 'Suchitoto',
        cantones: 26,
        codigo_postal: '01415',
      },
      {
        id_mun: '0716',
        value: 'Tenancingo',
        cantones: 10,
        codigo_postal: '01416',
      },
    ],
  },
  {
    id: '08',
    value: 'La Paz',
    cabecera: 'Zacatecoluca',
    'ISO3166-2': 'SV-PA',
    extension: 1223.61,
    municipios: [
      {
        id_mun: '0801',
        value: 'Cuyultitán',
        cantones: 2,
        codigo_postal: '01603',
      },
      {
        id_mun: '0802',
        value: 'El Rosario',
        cantones: 4,
        codigo_postal: '01604',
      },
      {
        id_mun: '0803',
        value: 'Jerusalén',
        cantones: 5,
        codigo_postal: '01605',
      },
      {
        id_mun: '0804',
        value: 'Mercedes La Ceiba',
        cantones: 2,
        codigo_postal: '01607',
      },
      {
        id_mun: '0805',
        value: 'Olocuilta',
        cantones: 12,
        codigo_postal: '01608',
      },
      {
        id_mun: '0806',
        value: 'Paraíso de Osorio',
        cantones: 2,
        codigo_postal: '01609',
      },
      {
        id_mun: '0807',
        value: 'San Antonio Masahuat',
        cantones: 5,
        codigo_postal: '01610',
      },
      {
        id_mun: '0808',
        value: 'San Emigdio',
        cantones: 2,
        codigo_postal: '01611',
      },
      {
        id_mun: '0809',
        value: 'San Francisco Chinameca',
        cantones: 5,
        codigo_postal: '01612',
      },
      {
        id_mun: '0810',
        value: 'San Juan Nonualco',
        cantones: 12,
        codigo_postal: '01613',
      },
      {
        id_mun: '0811',
        value: 'San Juan Talpa',
        cantones: 4,
        codigo_postal: '01614',
      },
      {
        id_mun: '0812',
        value: 'San Juan Tepezontes',
        cantones: 3,
        codigo_postal: '01615',
      },
      {
        id_mun: '0813',
        value: 'San Luis Talpa',
        cantones: 10,
        codigo_postal: '01616',
      },
      {
        id_mun: '0814',
        value: 'San Miguel Tepezontes',
        cantones: 2,
        codigo_postal: '01617',
      },
      {
        id_mun: '0815',
        value: 'San Pedro Masahuat',
        cantones: 15,
        codigo_postal: '01618',
      },
      {
        id_mun: '0816',
        value: 'San Pedro Nonualco',
        cantones: 7,
        codigo_postal: '01619',
      },
      {
        id_mun: '0817',
        value: 'San Rafael Obrajuelo',
        cantones: 6,
        codigo_postal: '01620',
      },
      {
        id_mun: '0818',
        value: 'Santa María Ostuma',
        cantones: 7,
        codigo_postal: '01621',
      },
      {
        id_mun: '0819',
        value: 'Santiago Nonualco',
        cantones: 22,
        codigo_postal: '01622',
      },
      {
        id_mun: '0820',
        value: 'Tapalhuaca',
        cantones: 3,
        codigo_postal: '01623',
      },
      {
        id_mun: '0821',
        value: 'Zacatecoluca',
        cantones: 39,
        codigo_postal: '01624',
      },
      {
        id_mun: '0822',
        value: 'San Luis La Herradura',
        cantones: 10,
        codigo_postal: '01606',
      },
    ],
  },
  {
    id: '09',
    value: 'Cabañas',
    cabecera: 'Sensuntepeque',
    'ISO3166-2': 'SV-CA',
    extension: 1103.51,
    municipios: [
      {
        id_mun: '0901',
        value: 'Cinquera',
        cantones: 8,
        codigo_postal: '01202',
      },
      {
        id_mun: '0902',
        value: 'Guacotecti',
        cantones: 3,
        codigo_postal: '01203',
      },
      {
        id_mun: '0903',
        value: 'Ilobasco',
        cantones: 18,
        codigo_postal: '01204',
      },
      {
        id_mun: '0904',
        value: 'Jutiapa',
        cantones: 7,
        codigo_postal: '01206',
      },
      {
        id_mun: '0905',
        value: 'San Isidro',
        cantones: 7,
        codigo_postal: '01207',
      },
      {
        id_mun: '0906',
        value: 'Sensuntepeque',
        cantones: 22,
        codigo_postal: '01201',
      },
      {
        id_mun: '0907',
        value: 'Tejutepeque',
        cantones: 6,
        codigo_postal: '01208',
      },
      {
        id_mun: '0908',
        value: 'Victoria',
        cantones: 10,
        codigo_postal: '01210',
      },
      {
        id_mun: '0909',
        value: 'Dolores',
        cantones: 6,
        codigo_postal: '01209',
      },
    ],
  },
  {
    id: '10',
    value: 'San Vicente',
    cabecera: 'San Vicente',
    'ISO3166-2': 'SV-SV',
    extension: 1184.02,
    municipios: [
      {
        id_mun: '1001',
        value: 'Apastepeque',
        cantones: 10,
        codigo_postal: '01702',
      },
      {
        id_mun: '1002',
        value: 'Guadalupe',
        cantones: 4,
        codigo_postal: '01703',
      },
      {
        id_mun: '1003',
        value: 'San Cayetano Istepeque',
        cantones: 3,
        codigo_postal: '01704',
      },
      {
        id_mun: '1004',
        value: 'Santa Clara',
        cantones: 6,
        codigo_postal: '01709',
      },
      {
        id_mun: '1005',
        value: 'Santo Domingo',
        cantones: 4,
        codigo_postal: '01710',
      },
      {
        id_mun: '1006',
        value: 'San Esteban Catarina',
        cantones: 7,
        codigo_postal: '01705',
      },
      {
        id_mun: '1007',
        value: 'San Ildefonso',
        cantones: 6,
        codigo_postal: '01706',
      },
      {
        id_mun: '1008',
        value: 'San Lorenzo',
        cantones: 4,
        codigo_postal: '01707',
      },
      {
        id_mun: '1009',
        value: 'San Sebastián',
        cantones: 6,
        codigo_postal: '01708',
      },
      {
        id_mun: '1010',
        value: 'San Vicente',
        cantones: 26,
        codigo_postal: '01701',
      },
      {
        id_mun: '1011',
        value: 'Tecoluca',
        cantones: 24,
        codigo_postal: '01711',
      },
      {
        id_mun: '1012',
        value: 'Tepetitán',
        cantones: 3,
        codigo_postal: '01712',
      },
      {
        id_mun: '1013',
        value: 'Verapaz',
        cantones: 8,
        codigo_postal: '01713',
      },
    ],
  },
  {
    id: '11',
    value: 'Usulután',
    cabecera: 'Usulután',
    'ISO3166-2': 'SV-US',
    extension: 2130.44,
    municipios: [
      {
        id_mun: '1101',
        value: 'Alegría',
        cantones: 8,
        codigo_postal: '03404',
      },
      {
        id_mun: '1102',
        value: 'Berlín',
        cantones: 17,
        codigo_postal: '03403',
      },
      {
        id_mun: '1103',
        value: 'California',
        cantones: 1,
        codigo_postal: '03404',
      },
      {
        id_mun: '1104',
        value: 'Concepción Batres',
        cantones: 9,
        codigo_postal: '03405',
      },
      {
        id_mun: '1105',
        value: 'El Triunfo',
        cantones: 5,
        codigo_postal: '03406',
      },
      {
        id_mun: '1106',
        value: 'Ereguayquín',
        cantones: 5,
        codigo_postal: '03407',
      },
      {
        id_mun: '1107',
        value: 'Estanzuelas',
        cantones: 9,
        codigo_postal: '03408',
      },
      {
        id_mun: '1108',
        value: 'Jiquilisco',
        cantones: 39,
        codigo_postal: '03409',
      },
      {
        id_mun: '1109',
        value: 'Jucuapa',
        cantones: 9,
        codigo_postal: '03410',
      },
      {
        id_mun: '1110',
        value: 'Jucuarán',
        cantones: 9,
        codigo_postal: '03411',
      },
      {
        id_mun: '1111',
        value: 'Mercedes Umaña',
        cantones: 9,
        codigo_postal: '03412',
      },
      {
        id_mun: '1112',
        value: 'Nueva Granada',
        cantones: 11,
        codigo_postal: '03413',
      },
      {
        id_mun: '1113',
        value: 'Ozatlán',
        cantones: 6,
        codigo_postal: '03415',
      },
      {
        id_mun: '1114',
        value: 'Puerto El Triunfo',
        cantones: 5,
        codigo_postal: '03417',
      },
      {
        id_mun: '1115',
        value: 'San Agustín',
        cantones: 20,
        codigo_postal: '03418',
      },
      {
        id_mun: '1116',
        value: 'San Buenaventura',
        cantones: 6,
        codigo_postal: '03419',
      },
      {
        id_mun: '1117',
        value: 'San Dionisio',
        cantones: 3,
        codigo_postal: '03420',
      },
      {
        id_mun: '1118',
        value: 'Santa Elena',
        cantones: 10,
        codigo_postal: '03422',
      },
      {
        id_mun: '1119',
        value: 'San Francisco Javier',
        cantones: 9,
        codigo_postal: '03421',
      },
      {
        id_mun: '1120',
        value: 'Santa María',
        cantones: 2,
        codigo_postal: '03423',
      },
      {
        id_mun: '1121',
        value: 'Santiago de María',
        cantones: 7,
        codigo_postal: '03424',
      },
      {
        id_mun: '1122',
        value: 'Tecapán',
        cantones: 4,
        codigo_postal: '03426',
      },
      {
        id_mun: '1123',
        value: 'Usulután',
        cantones: 8,
        codigo_postal: '03401',
      },
    ],
  },
  {
    id: '12',
    value: 'San Miguel',
    cabecera: 'San Miguel',
    'ISO3166-2': 'SV-SM',
    extension: 2077.1,
    municipios: [
      {
        id_mun: '1201',
        value: 'Carolina',
        cantones: 5,
        codigo_postal: '03302',
      },
      {
        id_mun: '1202',
        value: 'Ciudad Barrios',
        cantones: 11,
        codigo_postal: '03303',
      },
      {
        id_mun: '1203',
        value: 'Comacarán',
        cantones: 5,
        codigo_postal: '03304',
      },
      {
        id_mun: '1204',
        value: 'Chapeltique',
        cantones: 6,
        codigo_postal: '03305',
      },
      {
        id_mun: '1205',
        value: 'Chinameca',
        cantones: 20,
        codigo_postal: '03306',
      },
      {
        id_mun: '1206',
        value: 'Chirilagua',
        cantones: 11,
        codigo_postal: '03307',
      },
      {
        id_mun: '1207',
        value: 'El Tránsito',
        cantones: 6,
        codigo_postal: '03309',
      },
      {
        id_mun: '1208',
        value: 'Lolotique',
        cantones: 9,
        codigo_postal: '03311',
      },
      {
        id_mun: '1209',
        value: 'Moncagua',
        cantones: 10,
        codigo_postal: '03312',
      },
      {
        id_mun: '1210',
        value: 'Nueva Guadalupe',
        cantones: 3,
        codigo_postal: '03313',
      },
      {
        id_mun: '1211',
        value: 'Nuevo Edén de San Juan',
        cantones: 7,
        codigo_postal: '03314',
      },
      {
        id_mun: '1212',
        value: 'Quelepa',
        cantones: 3,
        codigo_postal: '03315',
      },
      {
        id_mun: '1213',
        value: 'San Antonio del Mosco',
        cantones: 2,
        codigo_postal: '03316',
      },
      {
        id_mun: '1214',
        value: 'San Gerardo',
        cantones: 4,
        codigo_postal: '03318',
      },
      {
        id_mun: '1215',
        value: 'San Jorge',
        cantones: 5,
        codigo_postal: '03319',
      },
      {
        id_mun: '1216',
        value: 'San Luis de la Reina',
        cantones: 4,
        codigo_postal: '03320',
      },
      {
        id_mun: '1217',
        value: 'San Miguel',
        cantones: 32,
        codigo_postal: '03301',
      },
      {
        id_mun: '1218',
        value: 'San Rafael Oriente',
        cantones: 4,
        codigo_postal: '03322',
      },
      {
        id_mun: '1219',
        value: 'Sesori',
        cantones: 11,
        codigo_postal: '03323',
      },
      {
        id_mun: '1220',
        value: 'Uluazapa',
        cantones: 3,
        codigo_postal: '03324',
      },
    ],
  },
  {
    id: '13',
    value: 'Morazán',
    cabecera: 'San Francisco Gotera',
    'ISO3166-2': 'SV-MO',
    extension: 1447.43,
    municipios: [
      {
        id_mun: '1301',
        value: 'Arambala',
        cantones: 2,
        codigo_postal: '03202',
      },
      {
        id_mun: '1302',
        value: 'Cacaopera',
        cantones: 7,
        codigo_postal: '03203',
      },
      {
        id_mun: '1303',
        value: 'Corinto',
        cantones: 5,
        codigo_postal: '03204',
      },
      {
        id_mun: '1304',
        value: 'Chilanga',
        cantones: 6,
        codigo_postal: '03205',
      },
      {
        id_mun: '1305',
        value: 'Delicias de Concepción',
        cantones: 2,
        codigo_postal: '03206',
      },
      {
        id_mun: '1306',
        value: 'El Divisadero',
        cantones: 7,
        codigo_postal: '03207',
      },
      {
        id_mun: '1307',
        value: 'El Rosario',
        cantones: 2,
        codigo_postal: '03208',
      },
      {
        id_mun: '1308',
        value: 'Gualococti',
        cantones: 2,
        codigo_postal: '03209',
      },
      {
        id_mun: '1309',
        value: 'Guatajiagua',
        cantones: 6,
        codigo_postal: '03210',
      },
      {
        id_mun: '1310',
        value: 'Joateca',
        cantones: 3,
        codigo_postal: '03211',
      },
      {
        id_mun: '1311',
        value: 'Jocoaitique',
        cantones: 2,
        codigo_postal: '03212',
      },
      { id_mun: '1312', value: 'Jocoro', cantones: 8, codigo_postal: '03213' },
      {
        id_mun: '1313',
        value: 'Lolotiquillo',
        cantones: 4,
        codigo_postal: '03214',
      },
      {
        id_mun: '1314',
        value: 'Meanguera',
        cantones: 4,
        codigo_postal: '03215',
      },
      {
        id_mun: '1315',
        value: 'Osicala',
        cantones: 5,
        codigo_postal: '03216',
      },
      {
        id_mun: '1316',
        value: 'Perquín',
        cantones: 3,
        codigo_postal: '03217',
      },
      {
        id_mun: '1317',
        value: 'San Carlos',
        cantones: 4,
        codigo_postal: '03218',
      },
      {
        id_mun: '1318',
        value: 'San Fernando',
        cantones: 2,
        codigo_postal: '03219',
      },
      {
        id_mun: '1319',
        value: 'San Francisco Gotera',
        cantones: 6,
        codigo_postal: '03201',
      },
      {
        id_mun: '1320',
        value: 'San Isidro',
        cantones: 2,
        codigo_postal: '03220',
      },
      {
        id_mun: '1321',
        value: 'San Simón',
        cantones: 6,
        codigo_postal: '03221',
      },
      {
        id_mun: '1322',
        value: 'Sensembra',
        cantones: 2,
        codigo_postal: '03222',
      },
      {
        id_mun: '1323',
        value: 'Sociedad',
        cantones: 8,
        codigo_postal: '03223',
      },
      { id_mun: '1324', value: 'Torola', cantones: 4, codigo_postal: '03224' },
      {
        id_mun: '1325',
        value: 'Yamabal',
        cantones: 4,
        codigo_postal: '03225',
      },
      {
        id_mun: '1326',
        value: 'Yoloaiquín',
        cantones: 2,
        codigo_postal: '03226',
      },
    ],
  },
  {
    id: '14',
    value: 'La Unión',
    cabecera: 'La Unión',
    'ISO3166-2': 'SV-UN',
    extension: 2074.34,
    municipios: [
      {
        id_mun: '1401',
        value: 'Anamorós',
        cantones: 8,
        codigo_postal: '03104',
      },
      {
        id_mun: '1402',
        value: 'Bolívar',
        cantones: 9,
        codigo_postal: '03104',
      },
      {
        id_mun: '1403',
        value: 'Concepción de Oriente',
        cantones: 4,
        codigo_postal: '03104',
      },
      {
        id_mun: '1404',
        value: 'Conchagua',
        cantones: 16,
        codigo_postal: '03104',
      },
      {
        id_mun: '1405',
        value: 'El Carmen',
        cantones: 11,
        codigo_postal: '03104',
      },
      {
        id_mun: '1406',
        value: 'El Sauce',
        cantones: 5,
        codigo_postal: '03104',
      },
      {
        id_mun: '1407',
        value: 'Intipucá',
        cantones: 2,
        codigo_postal: '03104',
      },
      {
        id_mun: '1408',
        value: 'La Unión',
        cantones: 13,
        codigo_postal: '03104',
      },
      {
        id_mun: '1409',
        value: 'Lilisque',
        cantones: 6,
        codigo_postal: '03104',
      },
      {
        id_mun: '1410',
        value: 'Meanguera del Golfo',
        cantones: 3,
        codigo_postal: '03104',
      },
      {
        id_mun: '1411',
        value: 'Nueva Esparta',
        cantones: 6,
        codigo_postal: '03104',
      },
      {
        id_mun: '1412',
        value: 'Pasaquina',
        cantones: 9,
        codigo_postal: '03104',
      },
      {
        id_mun: '1413',
        value: 'Polorós',
        cantones: 7,
        codigo_postal: '03104',
      },
      {
        id_mun: '1414',
        value: 'San Alejo',
        cantones: 19,
        codigo_postal: '03104',
      },
      {
        id_mun: '1415',
        value: 'San José',
        cantones: 4,
        codigo_postal: '03104',
      },
      {
        id_mun: '1416',
        value: 'Santa Rosa de Lima',
        cantones: 8,
        codigo_postal: '03104',
      },
      {
        id_mun: '1417',
        value: 'Yayantique',
        cantones: 4,
        codigo_postal: '03104',
      },
      {
        id_mun: '1418',
        value: 'Yucuaiquín',
        cantones: 9,
        codigo_postal: '03104',
      },
    ],
  },
]

export const JOBS = [
  { value: "ABOGADO", label: "ABOGADO" },
  { value: "ABOGADO Y NOTARIO", label: "ABOGADO Y NOTARIO" },
  { value: "AEROTECNICO", label: "AEROTECNICO" },
  { value: "ARQUITECTO", label: "ARQUITECTO" },
  { value: "ASTRONOMO", label: "ASTRONOMO" },
  { value: "AUDITOR", label: "AUDITOR" },
  { value: "BACHILLER", label: "BACHILLER" },
  { value: "BACHILLER AGRICOLA", label: "BACHILLER AGRICOLA" },
  { value: "BIBLIOTECARIO", label: "BIBLIOTECARIO" },
  { value: "CONTADOR", label: "CONTADOR" },
  { value: "DECORADORA", label: "DECORADORA" },
  { value: "DENTISTA", label: "DENTISTA" },
  { value: "DIBUJANTE DE ING.", label: "DIBUJANTE DE ING." },
  { value: "DIPLOMATICO", label: "DIPLOMATICO" },
  { value: "DISEÑADOR (A)", label: "DISEÑADOR (A)" },
  { value: "DISEÑADOR GRAFICO", label: "DISEÑADOR GRAFICO" },
  { value: "DR(A) EN PSICOLOGIA", label: "DR(A) EN PSICOLOGIA" },
  { value: "DR(A)CIRUGIA DENTAL", label: "DR(A)CIRUGIA DENTAL" },
  { value: "DR(A)QUIMICA INDUST", label: "DR(A)QUIMICA INDUST" },
  { value: "DR.(A) EN MEDICINA", label: "DR.(A) EN MEDICINA" },
  { value: "DR.EN CC DE LA EDUC", label: "DR.EN CC DE LA EDUC" },
  { value: "DR.JURISP.Y CC.SOC.", label: "DR.JURISP.Y CC.SOC." },
  { value: "DR. QUIMICA Y FARMAC", label: "DR. QUIMICA Y FARMAC" },
  { value: "EDITOR DE CINE", label: "EDITOR DE CINE" },
  { value: "EJECUTIVO DE VENTAS", label: "EJECUTIVO DE VENTAS" },
  { value: "EMPLEADO", label: "EMPLEADO" },
  { value: "ENFERMERA(O)", label: "ENFERMERA(O)" },
  { value: "ESCRITOR", label: "ESCRITOR" },
  { value: "ESTILISTA", label: "ESTILISTA" },
  { value: "ESTUDIANTE", label: "ESTUDIANTE" },
  { value: "ING. AGROINDUSTRIAL", label: "ING. AGROINDUSTRIAL" },
  { value: "ING. AGRONOMO", label: "ING. AGRONOMO" },
  { value: "ING. ARTES GRAFICAS", label: "ING. ARTES GRAFICAS" },
  { value: "ING. BIOLOGO", label: "ING. BIOLOGO" },
  { value: "ING. BIOQUIMICO", label: "ING. BIOQUIMICO" },
  { value: "ING. CIVIL", label: "ING. CIVIL" },
  { value: "ING. ELECTRICISTA", label: "ING. ELECTRICISTA" },
  { value: "ING. ELECTROMECAN.", label: "ING. ELECTROMECAN." },
  { value: "ING. ELECTRONICO", label: "ING. ELECTRONICO" },
  { value: "ING. EN ALIMENTOS", label: "ING. EN ALIMENTOS" },
  { value: "ING. EN COMPUTACION", label: "ING. EN COMPUTACION" },
  { value: "ING. INDUSTRIAL", label: "ING. INDUSTRIAL" },
  { value: "ING. MECANICO", label: "ING. MECANICO" },
  { value: "ING. QUIMICO", label: "ING. QUIMICO" },
  { value: "ING. TELECOMUNICAC.", label: "ING. TELECOMUNICAC." },
  { value: "ING.(A )BIOMEDICO", label: "ING.(A )BIOMEDICO" },
  { value: "ING.AGRON.ZOOTECNIS", label: "ING.AGRON.ZOOTECNIS" },
  { value: "ING.EN SISTEMAS INF", label: "ING.EN SISTEMAS INF" },
  { value: "ING.LOGISTIC Y DIST", label: "ING.LOGISTIC Y DIST" },
  { value: "LIC(A)ADMON PUBLICA", label: "LIC(A)ADMON PUBLICA" },
  { value: "LIC(A)DISEÑO INDUST", label: "LIC(A)DISEÑO INDUST" },
  { value: "LIC(A)EN SOCIOLOGIA", label: "LIC(A)EN SOCIOLOGIA" },
  { value: "LIC(A)MERC Y PUBLIC", label: "LIC(A)MERC Y PUBLIC" },
  { value: "LIC. ADMON MILITAR", label: "LIC. ADMON MILITAR" },
  { value: "LIC. ADMON.BANCARIA", label: "LIC. ADMON.BANCARIA" },
  { value: "LIC. ADMON.EMPRESAS", label: "LIC. ADMON.EMPRESAS" },
  { value: "LIC. ANTROPOL. SOC.", label: "LIC. ANTROPOL. SOC." },
  { value: "LIC. CC. EDUCAC.", label: "LIC. CC. EDUCAC." },
  { value: "LIC. CC. POLITICA", label: "LIC. CC. POLITICA" },
  { value: "LIC. CONTAD.PUBLICA", label: "LIC. CONTAD.PUBLICA" },
  { value: "LIC. DISEÑO AMBIENT", label: "LIC. DISEÑO AMBIENT" },
  { value: "LIC. DISEÑO GRAFICO", label: "LIC. DISEÑO GRAFICO" },
  { value: "LIC. EN ANTROPOLOGÍA", label: "LIC. EN ANTROPOLOGÍA" },
  { value: "LIC. EN CIENCIAS JUR", label: "LIC. EN CIENCIAS JUR" },
  { value: "LIC. EN COMPUTACION", label: "LIC. EN COMPUTACION" },
  { value: "LIC. EN ECONOMIA", label: "LIC. EN ECONOMIA" },
  { value: "LIC. EN EDUC.BASICA", label: "LIC. EN EDUC.BASICA" },
  { value: "LIC. EN ENFERMERIA", label: "LIC. EN ENFERMERIA" },
  { value: "LIC. EN ESTADISTICA", label: "LIC. EN ESTADISTICA" },
  { value: "LIC. EN FILOSOFIA", label: "LIC. EN FILOSOFIA" },
  { value: "LIC. EN FISICA", label: "LIC. EN FISICA" },
  { value: "LIC. EN GEOFISICA", label: "LIC. EN GEOFISICA" },
  { value: "LIC. EN HUMANIDADES", label: "LIC. EN HUMANIDADES" },
  { value: "LIC. EN IDIOMAS", label: "LIC. EN IDIOMAS" },
  { value: "LIC. EN LETRAS", label: "LIC. EN LETRAS" },
  { value: "LIC. EN MERCADEO", label: "LIC. EN MERCADEO" },
  { value: "LIC. EN OPTOMETRIA", label: "LIC. EN OPTOMETRIA" },
  { value: "LIC. EN PERIODISMO", label: "LIC. EN PERIODISMO" },
  { value: "LIC. EN SISTEMAS", label: "LIC. EN SISTEMAS" },
  { value: "LIC. ENTEOLOGIA", label: "LIC. ENTEOLOGIA" },
  { value: "LIC. IDIOMA INGLES", label: "LIC. IDIOMA INGLES" },
  { value: "LIC. LENGUAJE MODER", label: "LIC. LENGUAJE MODER" },
  { value: "LIC. NEGOCIOS INTER", label: "LIC. NEGOCIOS INTER" },
  { value: "LIC. QUIM. AGRICOLA", label: "LIC. QUIM. AGRICOLA" },
  { value: "LIC. RELAC. PUBL.", label: "LIC. RELAC. PUBL." },
  { value: "LIC. TRABAJO SOCIAL", label: "LIC. TRABAJO SOCIAL" },
  { value: "LIC.(A) EN BIOLOGIA", label: "LIC.(A) EN BIOLOGIA" },
  { value: "LIC.(A) EN FINANZAS", label: "LIC.(A) EN FINANZAS" },
  { value: "LIC.(A) EN TURISMO", label: "LIC.(A) EN TURISMO" },
  { value: "LIC.(A) PSICOLOGIA", label: "LIC.(A) PSICOLOGIA" },
  { value: "LIC.(A)ZOOTECNISTA", label: "LIC.(A)ZOOTECNISTA" },
  { value: "LIC.ADMN.FINA Y BANC", label: "LIC.ADMN.FINA Y BANC" },
  { value: "LIC.BIOLOGIA MARINA", label: "LIC.BIOLOGIA MARINA" },
  { value: "LIC.C Y ART MILITAR", label: "LIC.C Y ART MILITAR" },
  { value: "LIC.COMERCIALZACION", label: "LIC.COMERCIALZACION" },
  { value: "LIC.COMUNIC. SOCIAL", label: "LIC.COMUNIC. SOCIAL" },
  { value: "LIC.COMUNICACIONES", label: "LIC.COMUNICACIONES" },
  { value: "LIC.DIET.Y NUTRCIÓN", label: "LIC.DIET.Y NUTRCIÓN" },
  { value: "LIC.ECONOMIA Y NEG.", label: "LIC.ECONOMIA Y NEG." },
  { value: "LIC.ECOTECNOLGIA", label: "LIC.ECOTECNOLGIA" },
  { value: "LIC.EDUC P/LA SALUD", label: "LIC.EDUC P/LA SALUD" },
  { value: "LIC.EN ANESTESIOLOG", label: "LIC.EN ANESTESIOLOG" },
  { value: "LIC.EN ARTES PLASTI", label: "LIC.EN ARTES PLASTI" },
  { value: "LIC.EN CC. QUIMICAS", label: "LIC.EN CC. QUIMICAS" },
  { value: "LIC.EN CC. SOCIALES", label: "LIC.EN CC. SOCIALES" },
  { value: "LIC.EN FISIOTERAPIA", label: "LIC.EN FISIOTERAPIA" },
  { value: "LIC.EN MATEMATICAS", label: "LIC.EN MATEMATICAS" },
  { value: "LIC.ENTRENAM DEPORT", label: "LIC.ENTRENAM DEPORT" },
  { value: "LIC.LABORAT.CLINICO", label: "LIC.LABORAT.CLINICO" },
  { value: "LIC.NUTRIC.Y DIETET", label: "LIC.NUTRIC.Y DIETET" },
  { value: "LIC.QUIM. Y FARM.", label: "LIC.QUIM. Y FARM." },
  { value: "LIC.QUIMICA BIOLOG.", label: "LIC.QUIMICA BIOLOG." },
  { value: "LIC.QUIMICA INDUST.", label: "LIC.QUIMICA INDUST." },
  { value: "LIC.RADIOLOG.E IMAG", label: "LIC.RADIOLOG.E IMAG" },
  { value: "LIC.RELAC.INTERNAC.", label: "LIC.RELAC.INTERNAC." },
  { value: "LIC.SALUD MATER INF", label: "LIC.SALUD MATER INF" },
  { value: "MAEST.EN COMUN.ORG", label: "MAEST.EN COMUN.ORG" },
  { value: "MAESTRIA DIREC. EMP", label: "MAESTRIA DIREC. EMP" },
  { value: "MAESTRIA EN EDU SUP", label: "MAESTRIA EN EDU SUP" },
  { value: "MASTER EN ADMON", label: "MASTER EN ADMON" },
  { value: "MEDICO", label: "MEDICO" },
  { value: "MEDICO CIRUJANO", label: "MEDICO CIRUJANO" },
  { value: "MEDICO GINECO-OBSTE", label: "MEDICO GINECO-OBSTE" },
  { value: "MEDICO PEDIATRA", label: "MEDICO PEDIATRA" },
  { value: "MEDICO VETERINARIO", label: "MEDICO VETERINARIO" },
  { value: "MILITAR", label: "MILITAR" },
  { value: "MUSICO", label: "MUSICO" },
  { value: "NINGUNA", label: "NINGUNA" },
  { value: "NO ESPECIFICADA", label: "NO ESPECIFICADA" },
  { value: "ODONTOLOGO", label: "ODONTOLOGO" },
  { value: "OFTALMOLOGO", label: "OFTALMOLOGO" },
  { value: "OTROS", label: "OTROS" },
  { value: "PILOTO AVIADOR", label: "PILOTO AVIADOR" },
  { value: "PROF.(A) EDUC.MEDIA", label: "PROF.(A) EDUC.MEDIA" },
  { value: "PROF.(A) EN BIOLOGÍA", label: "PROF.(A) EN BIOLOGÍA" },
  { value: "PROF.EN EDUC FISICA", label: "PROF.EN EDUC FISICA" },
  { value: "PROFESOR", label: "PROFESOR" },
  { value: "SECRETARIA", label: "SECRETARIA" },
  { value: "TEC. ELECTRICISTA", label: "TEC. ELECTRICISTA" },
  { value: "TEC. EN COMPUTACION", label: "TEC. EN COMPUTACION" },
  { value: "TEC. EN ELECTRONICA", label: "TEC. EN ELECTRONICA" },
  { value: "TEC. EN MERCADEO", label: "TEC. EN MERCADEO" },
  { value: "TEC. EN RADIOLOGIA", label: "TEC. EN RADIOLOGIA" },
  { value: "TEC. EN TELEFONIA", label: "TEC. ENTELEFONIA" },
  { value: "TEC. EN TURISMO", label: "TEC. EN TURISMO" },
  { value: "TEC. ING. ELECTRICA", label: "TEC. ING. ELECTRICA" },
  { value: "TEC. ORTESIS Y PROT", label: "TEC. ORTESIS Y PROT" },
  { value: "TEC.COMUNICACIONES", label: "TEC.COMUNICACIONES" },
  { value: "TEC.DISEÑO Y CONSTR", label: "TEC.DISEÑO Y CONSTR" },
  { value: "TEC.EN AGRONOMIA", label: "TEC.EN AGRONOMIA" },
  { value: "TEC.EN AIRE ACONDIC", label: "TEC.EN AIRE ACONDIC" },
  { value: "TEC.EN REDES INFORM", label: "TEC.EN REDES INFORM" },
  { value: "TEC.ING.DE SISTEMAS", label: "TEC.ING.DE SISTEMAS" },
  { value: "TEC.ING.ELECTROMECA", label: "TEC.ING.ELECTROMECA" },
  { value: "TEC.ING.ELECTRONICA", label: "TEC.ING.ELECTRONICA" },
  { value: "TEC.MANT.AERONAUTIC", label: "TEC.MANT.AERONAUTIC" },
  { value: "TEC.MTO DE COMPUTAD", label: "TEC.MTO DE COMPUTAD" },
  { value: "TEC.PROG. DE COMPUT", label: "TEC.PROG. DE COMPUT" },
  { value: "TEC.TRABAJO SOCIAL", label: "TEC.TRABAJO SOCIAL" },
  { value: "TEC.VETERINARIO", label: "TEC.VETERINARIO" },
  { value: "TECN. EN ENFERMERIA", label: "TECN. EN ENFERMERIA" },
  { value: "TECN. EN ING. AGRICO", label: "TECN. EN ING. AGRICO" },
  { value: "TECN. EN ING. CIVIL", label: "TECN. EN ING. CIVIL" },
  { value: "TECN. EN ING. INDUST", label: "TECN. EN ING. INDUST" },
  { value: "TECN.EDUCACION SUPER", label: "TECN.EDUCACION SUPER" },
  { value: "TECN.EN GASTRONOMIA", label: "TECN.EN GASTRONOMIA" },
  { value: "TECN.EN ING.MECANIC", label: "TECN.EN ING.MECANIC" },
  { value: "TECN.EN LAB.QUIMICO", label: "TECN.EN LAB.QUIMICO" },
  { value: "TECNICO", label: "TECNICO" },
  { value: "TECNICO ALIMENTOS", label: "TECNICO ALIMENTOS" },
  { value: "TECNICO AUTOMOTRIZ", label: "TECNICO AUTOMOTRIZ" },
  { value: "TECNICO BANCARIO", label: "TECNICO BANCARIO" },
  { value: "TECNICO DENTAL", label: "TECNICO DENTAL" },
  { value: "TECNICO EN RAYOS X", label: "TECNICO EN RAYOS X" },
  { value: "TECNICO FARMACEUTICO", label: "TECNICO FARMACEUTICO" },
  { value: "TECNICO LAB. CLINICO", label: "TECNICO LAB. CLINICO" },
  { value: "TECNICO PERIODISMO", label: "TECNICO PERIODISMO" },
  { value: "TECNO EN FISIOTERAP", label: "TECNO EN FISIOTERAP" },
  { value: "TECNO. ANESTESISTA", label: "TECNO. ANESTESISTA" },
  { value: "TECNOLOGO MEDICO", label: "TECNOLOGO MEDICO" },
]